import React, { useEffect, useState } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, Typography, Space } from 'antd';
import {
  RobotOutlined,
  UserOutlined,
  TeamOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MessageOutlined,
  FileTextOutlined,
  SafetyOutlined,
  NotificationOutlined,
  StopOutlined,
  PictureOutlined,
  SendOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const Dashboard: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem('admin') || '{}');

  useEffect(() => {
    // 验证登录状态
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    navigate('/login');
  };

  const menuItems = [
    {
      key: '/dashboard/bots',
      icon: <RobotOutlined />,
      label: '机器人管理',
      onClick: () => navigate('/dashboard/bots'),
    },
    {
      key: '/dashboard/groups',
      icon: <TeamOutlined />,
      label: '群组管理',
      onClick: () => navigate('/dashboard/groups'),
    },
    {
      key: '/dashboard/channels',
      icon: <SendOutlined />,
      label: '频道管理',
      onClick: () => navigate('/dashboard/channels'),
    },
    {
      key: '/dashboard/auto-replies',
      icon: <MessageOutlined />,
      label: '自动回复管理',
      onClick: () => navigate('/dashboard/auto-replies'),
    },
    {
      key: '/dashboard/command-templates',
      icon: <FileTextOutlined />,
      label: '命令响应模板',
      onClick: () => navigate('/dashboard/command-templates'),
    },
    {
      key: '/dashboard/command-settings',
      icon: <FileTextOutlined />,
      label: '命令开关设置',
      onClick: () => navigate('/dashboard/command-settings'),
    },
    {
      key: '/dashboard/sensitive-words',
      icon: <StopOutlined />,
      label: '敏感词规则',
      onClick: () => navigate('/dashboard/sensitive-words'),
    },
    {
      key: '/dashboard/broadcast',
      icon: <NotificationOutlined />,
      label: '定时广播',
      onClick: () => navigate('/dashboard/broadcast'),
    },
    {
      key: '/dashboard/notifications',
      icon: <SendOutlined />,
      label: '通知模板',
      onClick: () => navigate('/dashboard/notifications'),
    },
    {
      key: '/dashboard/media',
      icon: <PictureOutlined />,
      label: '媒体管理',
      onClick: () => navigate('/dashboard/media'),
    },
    ...(admin.permission_level === 2
      ? [
          {
            key: '/dashboard/admins',
            icon: <UserOutlined />,
            label: '管理员管理',
            onClick: () => navigate('/dashboard/admins'),
          },
        ]
      : []),
  ];

  const userMenuItems = [
    {
      key: '2fa',
      icon: <SafetyOutlined />,
      label: '双因素认证',
      onClick: () => navigate('/dashboard/2fa'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: 20,
            fontWeight: 'bold',
          }}
        >
          {collapsed ? 'TG' : 'TG 管理后台'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
        />
      </Sider>

      <Layout>
        <Header style={{ padding: '0 16px', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: 16, width: 64, height: 64 }}
          />

          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <div style={{ lineHeight: '1.2' }}>
                <div style={{ marginBottom: 2 }}>
                  <Text strong>{admin.username}</Text>
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {admin.permission_level === 2 ? '超级管理员' : '普通管理员'}
                  </Text>
                </div>
              </div>
            </Space>
          </Dropdown>
        </Header>

        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
